import React from 'react';
import { Editor, EditorContent } from '@tiptap/react';
import { Tag } from '../../api/Tag';
import MenuBar from '../MenuBar';
import TagManager from '../TagManager';
import { Box, FormField, FormLabel, TextInput } from '../ui';

interface RecipeFormFieldsProps {
  title: string;
  onTitleChange: (value: string) => void;
  titleReadOnly?: boolean;
  ingredientsEditor: Editor | null;
  stepsEditor: Editor | null;
  availableTags: Tag[];
  selectedTagIds: number[];
  setAvailableTags: React.Dispatch<React.SetStateAction<Tag[]>>;
  setSelectedTagIds: React.Dispatch<React.SetStateAction<number[]>>;
  isAuthor: boolean;
  submitting: boolean;
  onMessage: (message: string, isError: boolean) => void;
  titleInputId?: string;
  ingredientsEditorId?: string;
  stepsEditorId?: string;
  tagsLabelId?: string;
}

const RecipeFormFields: React.FC<RecipeFormFieldsProps> = ({
  title,
  onTitleChange,
  titleReadOnly = false,
  ingredientsEditor,
  stepsEditor,
  availableTags,
  selectedTagIds,
  setAvailableTags,
  setSelectedTagIds,
  isAuthor,
  submitting,
  onMessage,
  titleInputId = 'title',
  ingredientsEditorId = 'ingredients-editor',
  stepsEditorId = 'steps-editor',
  tagsLabelId = 'tags-label',
}) => {
  return (
    <>
      <FormField label="Titre" htmlFor={titleInputId}>
        <TextInput
          id={titleInputId}
          value={title}
          onChange={(event) => onTitleChange(event.target.value)}
          readOnly={titleReadOnly}
          required
        />
      </FormField>
      <FormField label="Ingrédients" htmlFor={ingredientsEditorId}>
        <Box className="tiptap-editor-wrapper">
          <MenuBar editor={ingredientsEditor} />
          <EditorContent id={ingredientsEditorId} editor={ingredientsEditor} />
        </Box>
      </FormField>
      <FormField label="Étapes" htmlFor={stepsEditorId}>
        <Box className="tiptap-editor-wrapper">
          <MenuBar editor={stepsEditor} />
          <EditorContent id={stepsEditorId} editor={stepsEditor} />
        </Box>
      </FormField>
      <Box marginBottom={3}>
        <FormLabel id={tagsLabelId} display="block">Tags</FormLabel>
        <TagManager
          availableTags={availableTags}
          selectedTagIds={selectedTagIds}
          setAvailableTags={setAvailableTags}
          setSelectedTagIds={setSelectedTagIds}
          isAuthor={isAuthor}
          onMessage={onMessage}
          submitting={submitting}
        />
      </Box>
    </>
  );
};

export default RecipeFormFields;
